module.exports = __webpack_public_path__ + "static/media/speed.df0a0c42.svg";